import { useSearchParams } from "react-router-dom";
import { Package, Monitor, AppWindow, Terminal } from "lucide-react";
import PatchableAppsTable from "./PatchableAppsTable";
import PatchableOSTable from "./PatchableOSTable";
import Applications from "../Applications";
import CustomScripts from "../Settings/CustomScripts";

export default function PatchMain() {
    const [searchParams, setSearchParams] = useSearchParams();

    // Read from URL, default to 'all_apps' if not set or invalid
    const rawTab = searchParams.get("tab");
    const activeTab = rawTab === "os" ? "os" : rawTab === "all_apps" ? "all_apps" : rawTab === "scripts" ? "scripts" : "application";

    // Update URL when switching tabs
    const handleTabChange = (tab: 'all_apps' | 'application' | 'os' | 'scripts') => {
        setSearchParams({ tab });
    };

    return (
        <div className="flex flex-col h-full">
            {/* Header / Tabs Navigation */}
            <div className="flex items-center justify-between bg-gray-800 p-2 border border-gray-700 shadow-sm">

                {/* Tabs */}
                <div className="flex bg-gray-900/80 p-1 border rounded-lg border-gray-700/50">
                    <button
                        onClick={() => handleTabChange('all_apps')}
                        className={`flex items-center gap-2 px-5 py-2 rounded-md text-[11px] font-bold uppercase tracking-widest transition-all duration-300 border ${activeTab === 'all_apps'
                            ? 'bg-gray-800 border-gray-600 text-orange-400 shadow-sm'
                            : 'border-transparent text-gray-200 hover:text-gray-300 hover:bg-gray-800/50'
                            }`}
                    >
                        <AppWindow size={14} />
                        All Application
                    </button>
                    <button
                        onClick={() => handleTabChange('application')}
                        className={`flex items-center gap-2 px-5 py-2 rounded-md text-[11px] font-bold uppercase tracking-widest transition-all duration-300 border ${activeTab === 'application'
                            ? 'bg-gray-800 border-gray-600 text-orange-400 shadow-sm'
                            : 'border-transparent text-gray-200 hover:text-gray-300 hover:bg-gray-800/50'
                            }`}
                    >
                        <Package size={14} />
                        Patchable Application
                    </button>
                    <button
                        onClick={() => handleTabChange('os')}
                        className={`flex items-center gap-2 px-5 py-2 rounded-md text-[11px] font-bold uppercase tracking-widest transition-all duration-300 border ${activeTab === 'os'
                            ? 'bg-gray-800 border-gray-600 text-orange-400 shadow-sm'
                            : 'border-transparent text-gray-200 hover:text-gray-300 hover:bg-gray-800/50'
                            }`}
                    >
                        <Monitor size={14} />
                        OS Patching
                    </button>
                    <button
                        onClick={() => handleTabChange('scripts')}
                        className={`flex items-center gap-2 px-5 py-2 rounded-md text-[11px] font-bold uppercase tracking-widest transition-all duration-300 border ${activeTab === 'scripts'
                            ? 'bg-gray-800 border-gray-600 text-orange-400 shadow-sm'
                            : 'border-transparent text-gray-200 hover:text-gray-300 hover:bg-gray-800/50'
                            }`}
                    >
                        <Terminal size={14} />
                        Scripts
                    </button>
                </div>

                {/* Jobs Button */}

            </div>

            {/* Tab Content */}
            <div className="flex-1 px-3 pb-20">
                {activeTab === 'all_apps' && <Applications />}
                {activeTab === 'application' && <PatchableAppsTable />}
                {activeTab === 'os' && <PatchableOSTable />}
                {activeTab === 'scripts' && <CustomScripts />}
            </div>
        </div>
    );
}